import {isActionZoneAlert} from "_helperFunctions/isActionZoneAlert"

export const isAlertActionZone = function (car) {
    
    return car.ActionZoneId && isActionZoneAlert(car.ActionZoneId);
 };